import Designation from "../../../../components/company/organization/designation"

const DesignationPage = () => {
    return (
        <Designation/>
    )
}

export default DesignationPage;